// product-swatches.js
document.addEventListener('DOMContentLoaded', () => {
  // The exact option label you used in the snippet: change if different
  const TARGET_OPTION_NAME = 'Quantity'; // <- keep same as your snippet

  // find existing swatch block (inserted by snippet)
  const swatch = document.querySelector('.product-option-swatches');
  if (!swatch) return;

  // Helper: find product-variant block whose label matches the option name
  function findVariantBlockByName(name) {
    // common selector for variant blocks used by Dawn-like themes
    const blocks = document.querySelectorAll('.product-variants .product-variant, .product-variant');
    for (const b of blocks) {
      // find a child that contains the option name (common class product-variant__name or span)
      const titleEl = b.querySelector('.product-variant__name, .product-variant__name-text, .product-variant__heading, .product-variant span, h4');
      if (titleEl && titleEl.textContent.trim().toLowerCase().includes(name.toLowerCase())) {
        return b;
      }
      // fallback: check direct text nodes inside block
      if (b.textContent && b.textContent.trim().toLowerCase().includes(name.toLowerCase())) {
        return b;
      }
    }
    return null;
  }

  // find the target block and move swatches inside it (after heading)
  const targetBlock = findVariantBlockByName(TARGET_OPTION_NAME);
  if (targetBlock) {
    // Attempt to find the inner container where values are normally placed
    const containerCandidates = targetBlock.querySelectorAll('.product-variant__container, .product-variant__values, .product-variant-container, .product-variant__values-list, .product-variant__options');
    if (containerCandidates.length) {
      // insert at top of the first candidate
      containerCandidates[0].insertAdjacentElement('beforebegin', swatch);
    } else {
      // otherwise append to the block
      targetBlock.appendChild(swatch);
    }

    // hide the original pills that were rendered by the theme inside that block
    // We hide only children that look like pill groups (safely)
    const originalPills = targetBlock.querySelectorAll('.product-variant__value, .product-variant__values, .product-variant__items, .product-variant_container, .product-variants__values');
    originalPills.forEach(el => {
      // keep swatch visible by only hiding elements that are not our .product-option-swatches
      if (!el.closest('.product-option-swatches')) {
        el.style.display = 'none';
      }
    });
  } else {
    // If we didn't find the block, leave the swatches where they are but still try to hide a duplicate pills block nearby
    console.warn('[swatches] target option block not found:', TARGET_OPTION_NAME);
  }

  // Hook up click behavior (in case the earlier script didn't) so clicking swatch selects variant id
  const map = {};
  swatch.querySelectorAll('[data-option-value][data-variant-id]').forEach(el => {
    const v = el.getAttribute('data-option-value');
    const id = el.getAttribute('data-variant-id');
    if (v && id && !map[v]) map[v] = id;
  });

  function selectVariantById(variantId) {
    const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"], form.product-form input[name="id"]');
    if (idInput) {
      idInput.value = variantId;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    const variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect) {
      variantSelect.value = variantId;
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    const btn = document.querySelector('[data-variant-id="' + variantId + '"]');
    if (btn) { btn.click(); return true; }
    return false;
  }

  swatch.addEventListener('click', e => {
    const label = e.target.closest('.swatch-swatch');
    if (!label) return;
    // toggle active visuals
    swatch.querySelectorAll('.swatch-swatch').forEach(s => s.classList.remove('active'));
    label.classList.add('active');

    const val = label.getAttribute('data-option-value');
    const variantId = map[val];
    if (variantId) selectVariantById(variantId);
  });

  // Set initial active swatch if variant id already selected
  setTimeout(() => {
    const currentId = (document.querySelector('form[action*="/cart/add"] input[name="id"], form.product-form input[name="id"]') || {}).value;
    if (currentId) {
      const active = swatch.querySelector('[data-variant-id="' + currentId + '"]');
      if (active) active.classList.add('active');
    }
  }, 100);
});



